import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { combineLatest, filter, map, take } from "rxjs";
import { sessionFeature } from "../../authentication/store/session.reducer";
import { CredentialStore } from "../../authentication/data-access/credential.store";

export const groupsAccessGuard: CanActivateFn = () => {
    const store = inject(Store);
    const router = inject(Router);
    const credentials = inject(CredentialStore);

    return combineLatest([
        store.select(sessionFeature.selectIsSettled),
        store.select(sessionFeature.selectUser),
    ]).pipe(
        filter(([settled]) => settled),
        take(1),
        map(([, user]) =>
            credentials.readTokens()?.source !== "azure" &&
            user?.roles.some((role) => ["admin", "client_owner"].includes(role))
                ? true
                : router.createUrlTree(["/dashboard"])
        )
    );
};
